import type { CompleteSprintBody, Sprint } from '@tasks/contracts';

import { ConfirmDialog } from '../../components/ConfirmDialog';
import { CompleteSprintDialog } from './CompleteSprintDialog';
import { CreateSprintDialog } from './CreateSprintDialog';
import { CreateSprintIssueModal } from './SprintFormModal';
import type { SprintGroupView } from '../../lib/types';

export type BacklogDialogsProps = {
  readonly completeTarget: SprintGroupView | null;
  readonly futureSprints: readonly Sprint[];
  readonly isCompletePending: boolean;
  readonly completeError: string | null;
  readonly onCloseComplete: () => void;
  readonly onConfirmComplete: (body: CompleteSprintBody) => void;
  readonly sprintToDelete: SprintGroupView | null;
  readonly isDeletePending: boolean;
  readonly onCloseDelete: () => void;
  readonly onConfirmDelete: () => void;
  readonly isCreateOpen: boolean;
  readonly newSprintName: string;
  readonly isCreatePending: boolean;
  readonly onNewSprintNameChange: (name: string) => void;
  readonly onCloseCreate: () => void;
  readonly onCreateSprint: () => void;
  readonly createIssueOpen: boolean;
  readonly createIssueSprintId: string | null;
  readonly onCloseCreateIssue: () => void;
};

/** Все модальные окна экрана бэклога в одном месте. */
export function BacklogDialogs({
  completeTarget,
  futureSprints,
  isCompletePending,
  completeError,
  onCloseComplete,
  onConfirmComplete,
  sprintToDelete,
  isDeletePending,
  onCloseDelete,
  onConfirmDelete,
  isCreateOpen,
  newSprintName,
  isCreatePending,
  onNewSprintNameChange,
  onCloseCreate,
  onCreateSprint,
  createIssueOpen,
  createIssueSprintId,
  onCloseCreateIssue,
}: BacklogDialogsProps) {
  return (
    <>
      <CompleteSprintDialog
        open={completeTarget !== null}
        targetSprints={futureSprints.filter((sprint) => sprint.id !== completeTarget?.sprint.id)}
        incompleteCount={completeTarget ? completeTarget.issues.length - completeTarget.doneCount : 0}
        isPending={isCompletePending}
        error={completeError}
        onClose={onCloseComplete}
        onConfirm={onConfirmComplete}
      />

      <ConfirmDialog
        open={sprintToDelete !== null}
        title="Удалить спринт?"
        description="Удалить можно только пустой будущий спринт."
        confirmLabel="Удалить"
        isPending={isDeletePending}
        onConfirm={onConfirmDelete}
        onClose={onCloseDelete}
      />

      <CreateSprintDialog
        open={isCreateOpen}
        name={newSprintName}
        isPending={isCreatePending}
        onNameChange={onNewSprintNameChange}
        onClose={onCloseCreate}
        onCreate={onCreateSprint}
      />

      <CreateSprintIssueModal
        open={createIssueOpen}
        sprintId={createIssueSprintId}
        onClose={onCloseCreateIssue}
      />
    </>
  );
}
